import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    title: 'Fase de Enfriamiento',
    desc: 'Aplicas la auditoría digital para detener la hemorragia de valor inmediatamente.'
  }, {
    num: '02',
    title: 'El Mensaje Cebo',
    desc: 'Envías una de nuestras 5 plantillas de baja carga emocional para abrir el canal.'
  }, {
    num: '03',
    title: 'La Escalada',
    desc: 'Sigues el Mirroring Algorítmico para llevar la conversación del chat a la cita.'
  }];
  return <section className="py-24 relative overflow-hidden" data-id="element-158">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <FadeIn data-id="element-160">
          <div className="text-center mb-16" data-id="element-161">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-162">
              Cómo funciona el algoritmo
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-163">
              Un proceso de 3 fases diseñado para hackear la percepción.
            </p>
          </div>
        </FadeIn>

        <div className="relative" data-id="element-164">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-[#00d9ff]/30 to-transparent -translate-y-1/2 z-0" data-id="element-165" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-166">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-167">
                <div className="flex flex-col items-center text-center relative group" data-id="element-168">
                  <div className="w-20 h-20 rounded-full bg-[#0a0e1a] border-2 border-[#00d9ff] flex items-center justify-center text-2xl font-bold text-[#00d9ff] mb-6 shadow-[0_0_20px_rgba(0,217,255,0.2)] group-hover:bg-[#00d9ff] group-hover:text-[#0a0e1a] transition-all duration-300" data-id="element-169">
                    {step.num}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-170">
                    {step.title}
                  </h3>
                  <p className="text-gray-400" data-id="element-171">{step.desc}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}